import { render, staticRenderFns } from "./ChangeCallMenu.vue?vue&type=template&id=4792a7be&scoped=true"
import script from "./ChangeCallMenu.vue?vue&type=script&lang=js"
export * from "./ChangeCallMenu.vue?vue&type=script&lang=js"
import style0 from "./ChangeCallMenu.vue?vue&type=style&index=0&id=4792a7be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4792a7be",
  null
  
)

export default component.exports